export default __webpack_public_path__ + "static/char-s-29-zh-Hans-c5711ddab67c0778e025fe922f4c7bcf.webp";